export function LoomIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" fill="white" />
      <path
        d="M12 15.1279C10.2639 15.1279 8.87211 13.7211 8.87211 12C8.87211 10.2789 10.2789 8.87211 12 8.87211C13.7211 8.87211 15.1279 10.2789 15.1279 12C15.1279 13.7211 13.7361 15.1279 12 15.1279ZM23 10.8476H16.2952L22.102 7.49524L20.9497 5.50476L15.1429 8.85714L18.4952 3.05034L16.5048 1.89796L13.1524 7.70476V1H10.8476V7.70476L7.49524 1.89796L5.50476 3.05034L8.85714 8.85714L3.05034 5.50476L1.89796 7.49524L7.70476 10.8476H1V13.1524H7.70476L1.89796 16.5048L3.05034 18.4952L8.85714 15.1429L5.50476 20.9497L7.49524 22.102L10.8476 16.2952V23H13.1524V16.1605L16.5646 22.0721L18.4354 20.9946L15.0231 15.068L20.9497 18.4952L22.102 16.5048L16.2952 13.1524H23V10.8476Z"
        fill="#5259A4"
      />
    </svg>
  );
}
